"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.doInvoices = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const api_1 = __importDefault(require("constants/api"));
const constants_1 = require("constants/constants");
const doInvoices = async ({ params, callback }) => {
    const loginDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.LOGIN_DATA);
    const loginDataJSON = JSON.parse(loginDataStr ?? "{}");
    const clientDataStr = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
    const clientDataJSON = JSON.parse(clientDataStr ?? "{}");
    var formData = new FormData();
    formData.append("data", JSON.stringify({
        op: "cliente.comprobantes",
        token: loginDataJSON?.token,
        data: {
            cliid: clientDataJSON?.id,
            page: params?.data?.page,
            q: params?.data?.q,
            finicio: params?.data?.finicio,
            ffin: params?.data?.ffin,
            tipo: params?.data?.tipo,
        },
    }));
    fetch(api_1.default.URL_BASE, {
        method: "POST",
        headers: {
            ...api_1.default.HEADER_BASIC_AUTH,
        },
        body: formData,
    })
        .then(response => response.json())
        .then((json) => {
        switch (json?.status) {
            case api_1.default.WS_STATUS_SUCCESS:
                callback?.onSuccess(json);
                break;
            default:
                callback?.onFail?.(json?.msg ?? "Error desconocido");
                break;
        }
    })
        .catch(error => {
        console.error(error);
        callback?.onFail?.("Error!");
    });
};
exports.doInvoices = doInvoices;
